module.exports = __webpack_public_path__ + "static/img/default_user.95e7ec58.png";